// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2iCTFpuXuOeUL6F-Afd_17 {\n    margin-bottom: 8px;\n}\n\n._3Bu8JYyKDNHoSolMXvIsPQ {\n    margin-bottom: 24px;\n    max-width: 560px;\n}\n\n.JTTfYU2mL8j2wtUrxMLH6 ._2M4eU4trmFg553OAlfrIU {\n    color: #999;\n}\n\n._2M4eU4trmFg553OAlfrIU {\n    padding-left: 8px;\n}\n\n._2M4eU4trmFg553OAlfrIU,\n._3ck2REj74R_conbZ8gM5JR {\n    cursor: pointer;\n}\n\n._3ck2REj74R_conbZ8gM5JR {\n    align-items: center;\n    display: flex;\n    font-weight: 400;\n    margin-bottom: 0;\n}\n\ninput[type=checkbox].ICnUfOLgeCXklLCEUrCbj {\n    margin: 0;\n}\n\n._5MY3nZ1LRecfMDW6JX6Bd + ._5MY3nZ1LRecfMDW6JX6Bd {\n    margin-top: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"title": "_2iCTFpuXuOeUL6F-Afd_17",
	"description": "_3Bu8JYyKDNHoSolMXvIsPQ",
	"inactive": "JTTfYU2mL8j2wtUrxMLH6",
	"name": "_2M4eU4trmFg553OAlfrIU",
	"label": "_3ck2REj74R_conbZ8gM5JR",
	"toggle": "ICnUfOLgeCXklLCEUrCbj",
	"stage": "_5MY3nZ1LRecfMDW6JX6Bd"
};
module.exports = exports;
